import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import { HiPlusCircle, HiDotsHorizontal, HiOutlineCheck, HiPencilAlt, HiOutlineTrash } from "react-icons/hi";
import {
  useReactTable,
  getCoreRowModel
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useState } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

export function ShowMessage(type, msg) {
    return (
        <rsuite.Message showIcon type={type} closable>
            {msg}
        </rsuite.Message>
    )
}

export function GuidEmpty(){
    return "00000000-0000-0000-0000-000000000000";
}

export function ApiRoot(){
    return process.env.REACT_APP_API_ROOT || "https://api.arshehgostar.com/api";
}

// Shared "edit/delete" action-buttons column definition used by every
// CRUD list page's @tanstack/react-table columns array, so the button
// markup only has to be maintained in one place.
export function actionsColumn(onEdit, onDelete) {
    return {
        id: "actions",
        header: () => <div className="text-center me-8">عملیات</div>,
        cell: ({ row }) => (
            <rsuite.Row className="w-[100%] h-[100%]">
                <rsuite.Col xs={12} className="flex justify-end">
                    <rsuite.Button appearance="primary" onClick={() => onEdit(row.original.Id)}>
                        <HiPencilAlt />
                    </rsuite.Button>
                </rsuite.Col>
                <rsuite.Col xs={12}>
                    <rsuite.Button color="red" appearance="primary" onClick={() => onDelete(row.original.Id)}>
                        <HiOutlineTrash />
                    </rsuite.Button>
                </rsuite.Col>
            </rsuite.Row>
        ),
    };
}

//#region auth
const TOKEN_KEY = 'authToken';
const USER_KEY = 'authUser';

export function setAuth(token, user) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearAuth() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
}

export function getAuthToken() {
    return localStorage.getItem(TOKEN_KEY);
}

export function getAuthUser() {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
}

export function isLoggedIn() {
    return !!getAuthToken();
}

export function AuthHeader() {
    const token = getAuthToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
}
//#endregion
